import React, { useEffect, useRef, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import ServicePrivate from "../services/ServicePrivate";
import ApiBack from "../utils/domains/ApiBack";
import User from "../models/user";
import { Bell, Search } from "lucide-react";

interface Notificate {
  id: number;
  nombre: string;
  fecha_vencimiento: string;
  data_a: string;
  count: number;
}

export const Navbar = () => {
  //Variables to all tsx
  let userId: string;
  const myNavigate = useNavigate();
  const [arrayUsers, setArrayUsers] = useState<User>();
  const [show, setShow] = useState<boolean>();
  const [notificate, setNotificate] = useState<Notificate[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loading, setLoading] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  //const [isOpen, setIsOpen] = useState(false); // Set initial state based on rightSidebar prop

  // const toggleOffcanvas = () => {
  //   setIsOpen(!isOpen); // Toggle open/closed state
  // };

  const logout = () => {
    localStorage.removeItem("access");
    localStorage.removeItem("auth_token");
    localStorage.removeItem("user");
    myNavigate("/");
  };
  //function to error the Token on the time, using when token is invalid or expired
  const handleTokenError = () => {
    myNavigate("/"); // Redirigir a la página de inicio de sesión
  };

  const getProfessionals = async () => {
    try {
      const token: any = localStorage.getItem("access");
      if (!token) {
        handleTokenError();
        return;
      }
      const decoded: any = jwtDecode(token);

      if (decoded) {
        setArrayUsers(decoded);
        setLoading(false);
        userId = decoded.id;
        return;
      } else {
        console.error("El token no contiene información de usuario válida.");
        handleTokenError();
      }

    } catch (error) {
      console.error("Error fetching professionals:", error);
      setLoading(false);
      const token = localStorage.getItem("access");
      if (token === null) {
        handleTokenError();
      }
    }
  };

  const getAllIPS = async () => {
    try {
      const results = await ServicePrivate.requestGET(ApiBack.IPS_DEFEATE);
      if (results) {
        setNotificate(results.results);
        console.log(results)
        setLoading(false);
      } else {
        setLoading(true);
      }
    } catch (error) {
      console.error("Error fetching consents:", error);
      const token = localStorage.getItem("access");
      if (token === null) {
        handleTokenError();
      }
    }
  };

  // UseEffect to fetch user data once professionals are loaded
  // UseEffect to set a timeout for token expiration
  useEffect(() => {
    getProfessionals();
    const tokenTimeout = setTimeout(() => {
      localStorage.removeItem("access");
      handleTokenError(); // Redirect to login
    }, 43200000); // 12 hours
    getAllIPS();
    return () => clearTimeout(tokenTimeout); // clean to setTimeout next to token expiration
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setShow(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
        <div className="text-center  d-flex align-items-center justify-content-center">
          <Link className="navbar-brand brand-logo" to="/home">
            {/* <img src={imglogoR} alt="logo" width={50} height={50} /> */}
          </Link>
          <Link
            className="navbar-brand brand-logo-mini d-inline-block d-lg-none"
            to="/home/main"
          >
            {/* <img src={imglogoR} alt="logo" /> */}
          </Link>
        </div>
        <div className="navbar-menu-wrapper d-flex align-items-center">
          <Link to="/home/main" style={{ textDecoration: "none" }}>
            <div className="flex flex-col items-center sm:items-start text-center sm:text-left">
              <h1 className="mt-3 text-2xl font-bold bg-gradient-golden bg-clip-text tracking-tight font-bold" style={{ color: "#dabf5c" }}>
                ROCKY
              </h1>
              <p className="-mt-2 text-xs  font-bold" style={{ color: "#0f0f6f" }}>
                Sistema de información en atención primaria S.A.S
              </p>
            </div>
          </Link>
          <ul className="navbar-nav navbar-nav-right">
            <li className="nav-item nav-profile d-none d-sm-flex">
              <div className="d-flex align-items-center gap-1">

                <button type="button" className="d-none d-md-flex p-2">
                  <Search className="h-5 w-5 text-text-dark" strokeWidth={3} />
                </button>


                <div className="position-relative d-inline-block" ref={ref}>
                  {/* Botón campana */}
                  <button
                    type="button"
                    className="btn btn-link position-relative p-2"
                    onClick={() => { setShow(!show); getAllIPS() }}
                  >
                    <Bell className="h-5 w-5 text-dark" strokeWidth={2.5} />
                    {notificate.length > 0 && (
                      <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning text-dark">
                        {notificate.length}
                      </span>
                    )}
                  </button>

                </div>
              </div>
              {/* Dropdown de notificaciones */}
              {show && (
                <div
                  className="position-absolute ps-3 pe-3 shadow-lg rounded-4 notification-bubble"
                  style={{
                    position: "absolute",
                    top: "70px",
                    right: "20px",
                    minWidth: "20vh",
                    maxHeight: "40vh",
                    overflowY: "auto",
                    background: "#fff",
                    zIndex: 2000,
                  }}
                >
                  <div
                    className="sticky-header"
                    style={{
                      background: "#fff",
                      borderBottom: "1px solid #dee2e6",
                      position: "sticky",
                      top: "0px",
                      zIndex: 10,
                      padding: "0.5rem 1rem",  // más compacto
                      marginTop: "0px",
                    }}
                  >
                    <h6 className="fw-bold m-0" style={{ fontSize: "0.95rem" }}>
                      Notificaciones IPS
                    </h6>
                  </div>

                  <div
                    style={{
                      overflowY: "auto",
                      flex: 1,
                      padding: "5px",
                    }}
                  >
                    {notificate.length > 0 ? (
                      notificate.map((n) => (
                        <div
                          key={n.id}
                          className="dropdown-item d-flex justify-content-between"
                        >
                          <span>{n.nombre}</span>
                          <span className="text-danger fw-bold">{n.fecha_vencimiento}</span>
                        </div>
                      ))
                    ) : (
                      <div className="dropdown-item text-muted">
                        No hay IPS con prontos vencimientos.
                      </div>
                    )}
                  </div>
                </div>
              )}
      
              <Dropdown >
                <Dropdown.Toggle className="nav-link">
                  <div className="nav-profile-img">
                    {/* <img src="" alt="user" /> */}
                    <span className="availability-status online"></span>
                  </div>
                  <div className="nav-profile-text">
                    <p className="mb-1 fw-bold text-black fs-6">
                      <i className="fa-regular fa-user text-black fs-4"></i>
                      &nbsp;
                      {arrayUsers?.name}
                    </p>
                  </div>
                </Dropdown.Toggle>
                <div className="position-absolute" style={{"left":"200px"}}>
                <Dropdown.Menu className="navbar-dropdown text-center" >
                  <Dropdown.Item
                    href="!#"
                    onClick={(evt) => evt.preventDefault()}

                  >
                    <div className="dropdown-header text-center text-responsive">
                      <p className="mb-1 mt-3 d-flex justify-content-center text-responsive">
                        <i className="fa-solid fa-user-gear"></i>&nbsp;
                        {arrayUsers?.name}
                      </p>
                      <p className="font-weight-light text-muted mb-0">
                        <i className="fa-regular fa-envelope"></i>&nbsp;
                        {arrayUsers?.email}
                      </p>
                    </div>
                  </Dropdown.Item>
                  <Dropdown.Item
                    // href={}
                    onClick={() => {
                      if (userId)
                        myNavigate("/home/update-user/" + userId);
                    }}
                  >
                    <div className="dropdown-header text-center">
                      <p className=" d-flex justify-content-center">
                        <i className="fa-regular fa-pen-to-square"></i>
                        &nbsp;Actualizar
                      </p>
                    </div>
                  </Dropdown.Item>
                  <Dropdown.Item onClick={logout}>
                    <p className="preview-item d-flex align-items-center m-0 text-danger">
                      <i className="dropdown-item-icon icon-power ">
                        <i className="fa-solid fa-arrow-right-from-bracket"></i>
                      </i>
                      &nbsp;Cerrar sesión
                    </p>
                  </Dropdown.Item>
                </Dropdown.Menu>
                </div>

              </Dropdown>

            </li>
          </ul>
          {/* <button
            className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
            type="button"
            onClick={toggleOffcanvas}
          >
            <span className="icon-menu">dasda</span>
          </button> */}
        </div>
      </nav>
    </>
  );
};
